module.exports = __webpack_public_path__ + "img/R01_OFF.e8f1a799.jpg";